import { Form, Formik } from "formik";
import { Component } from "react";
import { FormattedMessage, type IntlShape, injectIntl } from "react-intl";
import { compose } from "nvent-web/utils/compose";

import {
  PrimaryBlueButton,
  SecondaryButton,
} from "nvent-web/components/Button";
import { DropdownField } from "nvent-web/components/form/DropdownField";
import { type DropdownOption } from "nvent-web/types/DropdownOption";

import style from "./AddThermostatForm.module.scss";

interface FormValues {
  productSkuId: string;
}

const initialValues: FormValues = {
  productSkuId: "",
};

interface ThermostatFormProps {
  onCancel: () => void;
  onSubmit: (values: FormValues) => void;
  thermostatOptions: DropdownOption[];
  isSubmitting?: boolean;
}

interface ThermostatFormInnerProps extends ThermostatFormProps {
  intl: IntlShape;
}

class ThermostatFormInner extends Component<ThermostatFormInnerProps> {
  render() {
    const { intl, onSubmit, onCancel, isSubmitting } = this.props;

    const areOptionsEmpty = this.props.thermostatOptions.length === 0;

    return (
      <Formik initialValues={initialValues} onSubmit={onSubmit}>
        {({ dirty }) => (
          <Form noValidate={true}>
            <h3 className={style.title}>
              <FormattedMessage id="thermostat.add.title" />
            </h3>

            <p className={style.notice}>
              <FormattedMessage id="thermostat.add.notice" />
            </p>

            <DropdownField
              name="productSkuId"
              label={<FormattedMessage id="form.thermostatName" />}
              options={this.props.thermostatOptions}
              disabled={areOptionsEmpty}
              placeholder={intl.formatMessage({
                id: "form.thermostatName.selectPlaceholder",
              })}
              required
            />

            {areOptionsEmpty && (
              <p className={style.warning}>
                <FormattedMessage id="thermostat.add.emptyOptions" />
              </p>
            )}

            <div className={style.actions}>
              <SecondaryButton className={style.cancelBtn} onClick={onCancel}>
                <FormattedMessage id="actions.cancel" />
              </SecondaryButton>
              <PrimaryBlueButton
                disabled={!dirty || isSubmitting}
                className={style.yesBtn}
                type="submit"
                loading={isSubmitting}
              >
                <FormattedMessage id="actions.add" />
              </PrimaryBlueButton>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

const ThermostatForm =
  compose<ThermostatFormProps>(injectIntl)(ThermostatFormInner);

export default ThermostatForm;
